import { forwardRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Input, type InputProps } from './Input';

export type DatePickerProps = Omit<InputProps, 'type'>;

/**
 * Date field primitive. Thin wrapper over the shared <Input> with
 * `type="date"`, so the native calendar control inherits the same border,
 * height, focus ring, and `invalid` styling as every other field.
 */
export const DatePicker = forwardRef<HTMLInputElement, DatePickerProps>(
  function DatePicker({ className, ...rest }, ref) {
    return (
      <Input
        ref={ref}
        type="date"
        className={cn('[color-scheme:light]', className)}
        {...rest}
      />
    );
  },
);
